/**
 * created by xcc
 *获取抖音链接方式
 */
import React, {Component} from 'react';
import {Scrollbars} from "react-custom-scrollbars";

export default class DouYinLink extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}

        this.content = [
            {
                step: "第一步",
                content: "进入抖音APP后点击搜索",
                image: "images/mediaDouYinLink/first.png"
            },
            {
                step: "第二步",
                content: "输入您要添加的抖音账号的名称并进行搜索（如下图）",
                image: "images/mediaDouYinLink/second.png"
            },
            {
                step: "第三步",
                content: "点击账号查看账号主页（如下图）",
                image: "images/mediaDouYinLink/third.png"
            },
            {
                step: "第四步",
                content: '点击账号主页右上角 "更多" 按钮（如下图）',
                image: "images/mediaDouYinLink/four.png"
            },
            {
                step: "第五步",
                content: '点击下方弹框中的 "分享主页" 按钮（如下图）',
                image: "images/mediaDouYinLink/five.png"
            },
            {
                step: "第六步",
                content: '点击 "复制链接" 按钮（如下图）',
                image: "images/mediaDouYinLink/six.png"
            },
            {
                step: "第七步",
                content: "复制成功（如下图）",
                image: "images/mediaDouYinLink/seven.png"
            },
            {
                step: "第八步",
                content: "使用微信等工具发送至电脑端再复制进行新媒体矩阵即可将抖音链接添加完成（如下图）",
                image: "images/mediaDouYinLink/eight.png"
            }
        ];
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        const scrollbarHeight = window.innerHeight - 90 -120;
        return (
            <div style={{height: window.innerHeight - 90, paddingBottom: '20px'}}>
                <div style={{
                    width: '100%', height: '120px', background: "#0050b3",
                    color: '#ffffff',
                    fontSize: '30px',
                    textAlign: "center",
                    lineHeight: '120px'

                }}>抖音链接添加教程
                </div>
                <Scrollbars autoHide style={{ height: scrollbarHeight}}>
                    <div style={{backgroundColor: "#fff",display:"grid", gridTemplate: "'a a a a' 'b b b b'",justifyContent: "space-around", padding: "20px 0", gap: "20px 0px"}} className={"douYinLinkPic"}>
                        {
                            this.content.map(item=>(
                                <div style={{width:259,}}>
                                    <div style={{
                                        fontWeight: "bold",
                                        fontSize: 16,
                                        color: "rgba(0, 0, 0, 0.85)",
                                        opacity: 1,
                                        marginBottom:8
                                    }}>{item.step}</div>
                                    <div style={{
                                        fontWeight: "bold",
                                        fontSize: 14,
                                        color: "rgba(0, 0, 0, 0.65)",
                                        opacity: 1,
                                        height: 30,
                                        marginBottom:39
                                    }}>{item.content}</div>
                                    <img src={item.image} style={{width:"100%"}}/>
                                </div>
                            ))
                        }
                    </div>
                    {/* <style>{`.douYinLinkPic img{width: 180px;height: 391px;object-fit: cover;}`}</style> */}
                </Scrollbars>
            </div>
        )
    }
}
